import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { applyStoredTheme } from './lib/theme';
import './index.css';

// Tema ANTES do primeiro render: aplicar depois faria a tela abrir clara e
// escurecer um quadro depois para quem escolheu o escuro.
applyStoredTheme();

const container = document.getElementById('root');

// Falhar alto aqui e proposital: sem o ponto de montagem a aplicacao nao existe,
// e uma tela branca silenciosa e muito mais cara de diagnosticar que um erro.
if (container === null) {
  throw new Error('Elemento #root ausente no index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
